import { useRef } from 'react';
import { PortalModal, useClickOutsideHandler } from '@web/utils';
import AddIcon from '@mui/icons-material/Add';

export interface EligibleDelivery {
  value: string;
  label: string;
}

interface MoveToToggleMenuProps {
  isOpen: boolean;
  eligibleDeliveries: EligibleDelivery[];
  setIsOpened: (isOpened: boolean) => void;
  moveToNewDelivery: (deliveryId: string) => void;
  moveToDifferentDelivery: () => void;
  moveToPickup: () => void;
  t: (key: string) => string;
  deliveryType: 'Pickup' | 'Delivery';
}

const MoveToToggleMenu = ({
  eligibleDeliveries,
  setIsOpened,
  moveToNewDelivery,
  moveToDifferentDelivery,
  moveToPickup,
  isOpen,
  t,
  deliveryType,
}: MoveToToggleMenuProps) => {
  return (
    <PortalModal isOpen={isOpen} setIsOpen={setIsOpened}>
      <div className=" overflow-hidden rounded-8-0 shadow border border-primary-grey right-0 bg-white z-3 mt-1-0 w-[300px]">
        <div className="w-full bg-primary-yellow relative h-2-5 flex items-center">
          <div
            className="rotate-45 cursor-pointer opacity-50 ml-auto mr-1-0"
            onClick={() => setIsOpened(false)}
          >
            <AddIcon className="w-2-4 h-2-4 text-primary" />
          </div>
        </div>

        <div className="flex flex-col text-body1 leading-1-5 gap-1-0 p-1-4">
          {eligibleDeliveries.length > 0 && (
            <>
              <p>{t('checkout.move_to')}</p>
              <div className="flex flex-col gap-y-1-0 text-body1 leading-1-5 pl-2-0 font-md pb-1-0">
                {eligibleDeliveries.map((delivery) => (
                  <p
                    className="cursor-pointer border-b border-primary-grey pb-1-0"
                    key={delivery.value}
                    onClick={() => {
                      moveToNewDelivery(delivery.value);
                      setIsOpened(false);
                    }}
                  >
                    {delivery.label}
                  </p>
                ))}
              </div>
            </>
          )}

          <p
            className="cursor-pointer last:pb-0"
            onClick={() => {
              moveToDifferentDelivery();
              setIsOpened(false);
            }}
          >
            {t('checkout.move_to_different')}
          </p>

          <p
            className="cursor-pointer"
            onClick={() => {
              moveToPickup();
              setIsOpened(false);
            }}
          >
            {deliveryType === 'Pickup'
              ? t('checkout.move_to_different_pickup')
              : t('checkout.move_to_pickup')}
          </p>
        </div>
      </div>
    </PortalModal>
  );
};

export default MoveToToggleMenu;
